import { MarketTrades } from "./../../models/company-trades";
import { SignalRService } from "src/app/services/signalr.service";
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { CompanyTrades } from "src/app/models/company-trades";
import { ApiService } from "src/app/services/api.service";
import { TranslateService } from "@ngx-translate/core";
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";

@Component({
  selector: "app-trades",
  templateUrl: "./trades.component.html",
  styleUrls: ["./trades.component.scss"],
})
export class TradesComponent implements OnInit {
  priceTrades: CompanyTrades;
  timeTrades: MarketTrades[];

  isTradesLoading: boolean;
  @Input() symbolCode: string;
  @Input() reuters: string;
  @Input() companyName: string;
  @Input() isLinked;
  isTime: any = true;
  vwapData: any;
  fromTime = new Date();
  toTime = new Date();
  lang: string;
  isRequestLoading: boolean = false;

  constructor(
    private _service: ApiService,
    private signalService: SignalRService,
    public translate: TranslateService
  ) {
    this.lang = this.translate.currentLang;

    this.fromTime.setHours(10, 0, 0, 0);
    this.toTime.setHours(14, 30, 0, 0);

    this.signalService.tradeChanges.subscribe((res) => {
      if (this.reuters != null) {
        res.forEach((element) => {
          if (element.SEC_BORAD_ID == this.symbolCode) {
            if (this.isTime && this.timeTrades.length > 0) {
              this.timeTrades.unshift(element as MarketTrades);
              if (this.timeTrades?.length > 50) {
                this.timeTrades.length = 50;
              }
            } else this.fetchCompanyTradesByPrice();
          }
        });
      }
    });
    // }
  }

  ngOnInit(): void {
    this.signalService.connectTradesUpdates();
  }
  ngOnDestroy(): void {
    this.signalService.disconnectTradesSignalr();
  }

  toggleView(value) {
    if (this.symbolCode) this.isTradesLoading = true;
    this.isTime = value;
    if (value) this.fetchCompanyTradesByTime();
    else this.fetchCompanyTradesByPrice();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.symbolCode = changes.symbolCode.currentValue;
    if (this.symbolCode) {
      this.isTradesLoading = true;
      if (this.isTime) this.fetchCompanyTradesByTime();
      else this.fetchCompanyTradesByPrice();
    }
  }

  fetchCompanyTradesByPrice() {
    // this.isTradesLoading = true;

    this._service.fetchCompanyTrades(this.symbolCode).subscribe((res) => {
      this.isTradesLoading = false;
      this.priceTrades = res as CompanyTrades;
    });
  }
  fetchCompanyTradesByTime() {
    this._service.fetchCompanyTradesByTime(this.symbolCode).subscribe((res) => {
      this.isTradesLoading = false;
      this.timeTrades = res as MarketTrades[];
    });
  }
      fetchExpectedVwap() {
    this._service.fetchExpectedVwap(this.symbolCode).subscribe(result => {
      this.vwapData = result
    })
  }
  exportRecentTrades() {
    this.fetchExpectedVwap();
    const isArabic = this.lang === 'ar';

      Swal.fire({
    title: isArabic ? "نظام التداول" : "OMS",
    text: isArabic ? "هل تريد تأكيد تصدير الصفقات الأخيرة؟" : "Confirm to export recent trades?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: isArabic ? "نعم" : "Yes",
    cancelButtonText: isArabic ? "لا" : "No",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isRequestLoading = true;

        this.fetchExpectedVwap();
          const labels = {
            Time: isArabic ? "الوقت" : "Time",
            Quantity: isArabic ? "الكمية" : "Quantity",
            Price: isArabic ? "السعر" : "Price",
            Change: isArabic ? "التغير" : "Change"
          };
          const recentTrades = isArabic ? "الصفقات الأخيرة" : "Recent Trades";
        this._service.fetchSymbolTradesByTime(this.symbolCode, 0, this.vwapData?.TRADESCOUNT, this.fromTime.toLocaleString(), this.toTime.toLocaleString()).subscribe((result: any) => {
          var resultToExport = result.map((item: any) => {
            return {
              [labels.Time]: new Date(item?.EXEC_TIME).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }),
              [labels.Quantity]: item?.TRADE_VOLUME,
              [labels.Price]: item?.TRADE_PRICE,
              [labels.Change]: item?.CHANGE_PRC + "%"
            }
          })
          this.exportToExcelFromData(resultToExport, `${recentTrades}_${this.reuters}`)
        })
        this.isRequestLoading = false;
      }
    })
  }

    exportToExcelFromData(data: any, Sheetname: string) {
    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(data)
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
    XLSX.writeFile(workbook, Sheetname + '.xlsx')
  }
}
